export default __webpack_public_path__ + "static/media/mp_documents_download_green.be54458b.svg";